import SuppliesDetail from "../../components/SuppliesDetail/SuppliesDetail";

const SuppliesDetailPage = () => {
  return <SuppliesDetail />;
};

export default SuppliesDetailPage;
